import './src/css/main.css'
const React = require('react')
const Layout = require('./src/components/Layout').default
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

const addScript = url => {
  const script = document.createElement('script')
  script.src = url
  script.async = true
  document.body.appendChild(script)
}

export const onClientEntry = () => {
  window.onload = () => {
    addScript(
      'https://cdn.knightlab.com/libs/juxtapose/latest/js/juxtapose.min.js'
    )
  }
}

// const React = require('react')
// const Layout = require('./src/components/Layout').default
// export function wrapPageElement({ element, props }) {
//   return <Layout {...props}>{element}</Layout>
// }
// ./gatsby-browser.js
// import React from 'react'
// import { silentAuth } from './src/utils/auth'

// class SessionCheck extends React.Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       loading: true,
//     }
//   }

//   handleCheckSession = () => {
//     this.setState({ loading: false })
//   }

//   componentDidMount() {
//     silentAuth(this.handleCheckSession)
//   }

//   render() {
//     return (
//       this.state.loading === false && (
//         <React.Fragment>{this.props.children}</React.Fragment>
//       )
//     )
//   }
// }

// export const wrapRootElement = ({ element }) => {
//   return <SessionCheck>{element}</SessionCheck>
// }
